// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Timesheet  {
    _originalTypeClassName = "Loom.BO.Timesheet";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Timesheet.translate = translateService;
}
this.TimesheetEntries = [];
this.Projects = [];
this.Attachments = [];
this.Id = null;
this.Month = null;
this.Notes = null;
this.DateSubmitted = null;
this.DateApproved = null;
this.TotalHoursReported = null;
this.WPs = null;
this.ForecastTotal = null;
this.Status = Domain.TimesheetStatus.Draft;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Month:any;
Notes:any;
DateSubmitted:any;
DateApproved:any;
TotalHoursReported:any;
WPs:any;
ForecastTotal:any;
Status:any;
EmploymentContract:any;
TimesheetEntries:any;
ApprovedBy:any;
SubmittedBy:any;
Projects:any;
Attachments:any;
static setEmploymentContract = ($this, value) => {
var oldValue = $this.EmploymentContract;
$this.EmploymentContract = value;
if (value != null) {
}
}
static setTimesheetEntries = ($this, items) => {
                if (items == null) items = [];
                if ($this.TimesheetEntries == null) $this.TimesheetEntries = [];

                const copyItems = Common.cloneObject(items);

                while ($this.TimesheetEntries.length > 0) {
                    Domain.Timesheet.removeTimesheetEntries($this, $this.TimesheetEntries[0]);
                }

                Domain.Timesheet.addManyTimesheetEntries($this, copyItems);
            }
static addManyTimesheetEntries = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Timesheet.addTimesheetEntries($this, items[i]);
                }
            }
static addTimesheetEntries = ($this, item) => {
                if ($this.TimesheetEntries == null) $this.TimesheetEntries = [];
                if (item == null || $this.TimesheetEntries.indexOf(item) > -1) return;
                $this.TimesheetEntries.push(item);
if (item.Timesheet != $this) {
Domain.TimesheetEntry.setTimesheet(item, $this);
}
}
static addRangeTimesheetEntries = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Timesheet.addTimesheetEntries($this, item));
            }
static removeTimesheetEntries = ($this, item) => {
                if ($this == null || $this.TimesheetEntries == null || $this.TimesheetEntries.indexOf(item) === -1) return;
                var _index = $this.TimesheetEntries.indexOf(item);
                $this.TimesheetEntries.splice(_index, 1);
item.Timesheet = null;
}
static clearTimesheetEntries = ($this) => { $this.TimesheetEntries = null; }
static setApprovedBy = ($this, value) => {
var oldValue = $this.ApprovedBy;
$this.ApprovedBy = value;
if (value != null) {
}
}
static setSubmittedBy = ($this, value) => {
var oldValue = $this.SubmittedBy;
$this.SubmittedBy = value;
if (value != null) {
}
}
static setProjects = ($this, items) => {
                if (items == null) items = [];
                if ($this.Projects == null) $this.Projects = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Projects.length > 0) {
                    Domain.Timesheet.removeProjects($this, $this.Projects[0]);
                }

                Domain.Timesheet.addManyProjects($this, copyItems);
            }
static addManyProjects = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Timesheet.addProjects($this, items[i]);
                }
            }
static addProjects = ($this, item) => {
                if ($this.Projects == null) $this.Projects = [];
                if (item == null || $this.Projects.indexOf(item) > -1) return;
                $this.Projects.push(item);
if (item.Timesheet != $this) {
Domain.TimesheetProjectSummary.setTimesheet(item, $this);
}
}
static addRangeProjects = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Timesheet.addProjects($this, item));
            }
static removeProjects = ($this, item) => {
                if ($this == null || $this.Projects == null || $this.Projects.indexOf(item) === -1) return;
                var _index = $this.Projects.indexOf(item);
                $this.Projects.splice(_index, 1);
item.Timesheet = null;
}
static clearProjects = ($this) => { $this.Projects = null; }
static setAttachments = ($this, items) => {
                if (items == null) items = [];
                if ($this.Attachments == null) $this.Attachments = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Attachments.length > 0) {
                    Domain.Timesheet.removeAttachments($this, $this.Attachments[0]);
                }

                Domain.Timesheet.addManyAttachments($this, copyItems);
            }
static addManyAttachments = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Timesheet.addAttachments($this, items[i]);
                }
            }
static addAttachments = ($this, item) => {
                if ($this.Attachments == null) $this.Attachments = [];
                if (item == null || $this.Attachments.indexOf(item) > -1) return;
                $this.Attachments.push(item);
}
static addRangeAttachments = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Timesheet.addAttachments($this, item));
            }
static removeAttachments = ($this, item) => {
                if ($this == null || $this.Attachments == null || $this.Attachments.indexOf(item) === -1) return;
                var _index = $this.Attachments.indexOf(item);
                $this.Attachments.splice(_index, 1);
}
static clearAttachments = ($this) => { $this.Attachments = null; }

static CalculateProjectSummary($this: any): any{for (let _ie = 0; _ie < ($this?.TimesheetEntries == null ? 0 : $this?.TimesheetEntries.length); _ie++) {let e = $this?.TimesheetEntries[_ie];let ps = $this?.Projects?.linq?.where((p) => CLMS.Framework.Number.Equal(() => p.Project.Id, () => e.WorkPackage.Project.Id))?.firstOrDefault(null);if ((ps == null)) {ps = new Domain.TimesheetProjectSummary();ps.Actual = 0;Domain.TimesheetProjectSummary.setProject(ps, e?.WorkPackage?.Project);$this?.Projects?.add(ps);}}
for (let _is = 0; _is < ($this?.Projects == null ? 0 : $this?.Projects.length); _is++) {let s = $this?.Projects[_is];s.Actual = Domain.TimesheetProjectSummary.GetActual(s);}
}
static GetTotalHoursReported($this: any): any{return $this?.TimesheetEntries?.linq?.sum((e) => e?.HoursWorked);
}
static GetWPs($this: any): any{try {return CLMS.Framework.String.Join(", ", $this?.TimesheetEntries?.linq?.select((a) => a?.WorkPackage?.Project?.Acronym + " - " + a?.WorkPackage?.WPNumber)?.toArray());}
catch (x) {console.debug("Error in GetWPs: " + x?.message);return "";}
}
static ValidateTimesheets($this: any, project: any,relationship: any,fromMonth: any,toMonth: any,timesheetId: any,org: any): any{}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}